import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
const links = [{
  label: 'Juegos digitales',
  href: '#juegos'
}, {
  label: 'Reseñas',
  href: '#resenas'
}, {
  label: 'Modalidades',
  href: '#modalidades'
}, {
  label: 'Reseña al instante',
  href: '#resena-instante'
}];
export function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <nav className="fixed left-0 right-0 z-30 transition-all duration-300" style={{
    top: '76px',
    backgroundColor: '#000000',
    borderBottom: '1px solid #c0392b',
    boxShadow: scrolled ? '0 4px 20px rgba(192,57,43,0.3)' : 'none'
  }} data-id="element-182">
      {/* Mobile menu */}
      {open && <div className="md:hidden border-t px-4 py-4 flex flex-col gap-4" style={{
      backgroundColor: '#0d0d0d',
      borderColor: '#c0392b'
    }} data-id="element-183">
          {links.map(l => <a key={l.label} href={l.href} className="text-sm text-gray-300 hover:text-white transition-colors uppercase tracking-wide" onClick={() => setOpen(false)} data-id="element-184">
              {l.label}
            </a>)}
          <button className="w-full py-3 text-sm font-bold text-white rounded" style={{
        backgroundColor: '#c0392b'
      }} onClick={() => {
        setOpen(false);
        document.getElementById('oferta')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} data-id="element-185">
            COMPRAR 4x1 AHORA
          </button>
        </div>}
    </nav>;
}